const sortTableByAlphabet = (a, b) => {
  if (!a) return 1
  return a?.localeCompare?.(b)
}
export default sortTableByAlphabet
